// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"b144e6ef","218":"b249ddbe","406":"043c92ea","738":"9caeeb1a","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};